import router from '@/router'
import store from '@/store'

router.beforeEach(async (to, from, next) => {
  const _query = to.query
  if (_query.ticket) {
    await store.dispatch('user/loginValidate', _query.ticket)
    delete _query.ticket
    if (_query.channel) {
      delete _query.channel
    }
    if (_query.invitePeople) {
      delete _query.invitePeople
    }
    next({
      path: to.path,
      query: _query,
    })
  } else {
    if (localStorage.userInfo) {
      store.commit('user/changeKey', {
        userInfo: JSON.parse(localStorage.userInfo),
      })
    }
    next()
  }
})
